var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascriptThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 0H0V54H54V0Z",
    fill: "#F1DC50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24.75C27 35.4357 27 41.4357 27 42.75C27 44.7214 25.8235 47.25 22.5 47.25C17.1329 47.25 16.875 42.75 16.875 42.75M46.7774 30.4111C45.4272 28.137 43.6374 27 41.408 27C37.9268 27 36 29.25 36 31.5C36 33.75 37.125 36 41.6439 37.125C44.5195 37.8409 47.25 39.375 47.25 42.75C47.25 46.125 44.2902 47.25 41.625 47.25C38.2189 47.25 35.9689 45.75 34.875 42.75",
    stroke: "#333333",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptThin);
export default __webpack_public_path__ + "static/media/javascript-thin.5985da5677fcdf95f95bbee5e43a770c.svg";
export { ForwardRef as ReactComponent };